import CircularProgress from '@mui/material/CircularProgress';


export default function LoadingCircle() {
  return (
    <CircularProgress
      role="status"
      aria-label="Carregando"
      sx={{
      "marginY": "24px",
      // "height": "88px",
      "color": theme => theme.palette.accent.main,
      }}
    />
  );
}